<template>
  <div>
    <header class="hero-multi">
      <div class="bb-container">
        <div class="hero-multi__container">
          <div class="hero-multi__left">
            <h1 class="hero-multi__title">
              A wishlist
              <span class="hero-multi__break">multi-loja</span> para tudo o que você deseja
            </h1>
            <div class="hero-multi__actions">
              <bbButton
                label="Crie sua lista de desejos"
                class="button--lg button--accent"
                @click="$router.push({ name: 'signup-pt' })"
              />
              <!-- <a
                @click="$router.push({ name: 'guest', params: { id: exampleListId } })"
                class="link link--bold link--underline"
              >
                Ver uma lista de exemplo
              </a> -->
            </div>
          </div>
          <div class="hero-multi__cover">
            <picture>
              <source
                srcset="../../assets/img/covers/cover-fr-hero@2x.png"
                media="(min-width: 1399px) and (min-device-pixel-ratio: 2)"
              />
              <img src="../../assets/img/covers/cover-multi-hero.png" alt="" />
            </picture>
          </div>
        </div>
      </div>
    </header>
    <section class="rate-app">
      <div class="bb-container">
        <div class="rate-app__container">
          <div class="rate-app__title">
            Mais de 80.000 pessoas já usaram <br />o HelloBB para realizar seus desejos
          </div>
          <div class="rate-app__card">
            <div class="rate-app__item">
              <div class="rate-app__logo">
                <img src="../../assets/img/ico/ico-google-play.svg" alt="Google Play" />
              </div>
              <div class="rate-app__rate">4,8</div>
              <div class="rate-app__star">
                <img src="../../assets/img/ico/ico-star-fill.svg" alt="" />
              </div>
            </div>
            <hr />
            <div class="rate-app__item">
              <div class="rate-app__logo">
                <img src="../../assets/img/ico/ico-app-store.svg" alt="Apple App Store" />
              </div>
              <div class="rate-app__rate">4,8</div>
              <div class="rate-app__star">
                <img src="../../assets/img/ico/ico-star-fill.svg" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="tiendas-list">
      <div class="tiendas-list__title">Receba qualquer produto de qualquer loja</div>
      <div class="tiendas-list__items">
        <VueSlickCarousel v-bind="shopSlider">
          <div class="tiendas-list__item">
            <img 
              loading="lazy" 
              src="../../assets/img/logos/logo-mercado-livre.webp" 
              alt="Mercado Livre" />
          </div>
          <div class="tiendas-list__item">
            <img
              loading="lazy"
              src="../../assets/img/logos/logo-af-amazon.svg"
              alt="Amazon"
            />
          </div>
          <div class="tiendas-list__item">
            <img
              loading="lazy"
              src="../../assets/img/logos/logo-shein.webp"
              alt="Shein"
            />
          </div>
          <div class="tiendas-list__item">
            <img
              loading="lazy"
              src="../../assets/img/logos/logo-af-etsy.svg"
              alt="Etsy"
            />
          </div>
          <div class="tiendas-list__item">
            <img
              loading="lazy"
              src="../../assets/img/logos/logo-af-sephora.svg"
              alt="Sephora"
            />
          </div>
          <div class="tiendas-list__item">
            <img loading="lazy" src="../../assets/img/logos/logo-af-hm.svg" alt="H & M" />
          </div>
          <div class="tiendas-list__item">
            <img
              loading="lazy"
              src="../../assets/img/logos/logo-shopee.webp"
              alt="Shopee"
            />
          </div>
          <div class="tiendas-list__item">
            <img
              loading="lazy"
              src="../../assets/img/logos/logo-af-zara.svg"
              alt="Zara"
            />
          </div>
        </VueSlickCarousel>
      </div>
    </section>
    <section class="hbbm-verticales">
      <div class="hbbm-verticales__container bb-container">
        <h3 class="hbbm-verticales__title">
          Perfeito para <span>qualquer ocasião</span>
        </h3>
        <div class="hbbm-verticales__items">
          <VueSlickCarousel v-bind="verticalesSlider" dotsClass="slick-dots">
            <div
              class="hbbm-verticales__item"
              v-for="item in verticales"
              :key="item.name"
            >
              <component
                :is="item.path ? 'router-link' : 'div'"
                :to="item.path || undefined"
                class="hbbm-verticales__content"
              >
                <div class="hbbm-verticales__name">
                  {{ item.name }}
                </div>
                <picture class="hbbm-verticales__image">
                  <img :src="item.cover" :alt="item.name" />
                </picture>
              </component>
            </div>
          </VueSlickCarousel>
        </div>
      </div>
    </section>
    <section class="app-avanzada">
      <div class="bb-container">
        <div class="app-avanzada__container">
          <aside class="app-avanzada__left">
            <div class="app-avanzada__title">
              O melhor App para suas listas de desejos é <span>gratuito</span>
            </div>
            <div class="app-avanzada__description">
              Descubra nosso aplicativo gratuito com tudo o que você precisa para criar a wishlist perfeita.
            </div>
            <!-- <div class="app-avanzada__actions">
              Descubre nuestra App gratuita con todo lo que necesitas para hacer tu lista
              perfecta.
            </div> -->
            <div class="app-avanzada__stores" target="_blank">
              <a :href="$t('links.mobileAppUrlAndroid', 'es-ES')">
                <img
                  loading="lazy"
                  src="../../assets/img/logos/logo-app-google.en-GB.svg"
                  alt=""
                  width="140"
                  height="40"
                />
              </a>
              <a :href="$t('links.mobileAppUrlIos', 'es-ES')" target="_blank">
                <img
                  loading="lazy"
                  src="../../assets/img/logos/logo-app-appstore.en-GB.svg"
                  alt=""
                  width="140"
                  height="40"
                />
              </a>
            </div>
          </aside>
          <picture class="app-avanzada__cover">
            <img
              src="../../assets//img/covers/mockup_lista_general_EN.png"
              :alt="$t('home2.appTitle')"
            />
          </picture>
        </div>
      </div>
    </section>
    <main class="home-beneficios">
      <div class="bb-container">
        <div class="home-beneficios__items">
          <section class="home-beneficios__item">
            <div class="home-beneficios__cover">
              <img src="../../assets/img/covers/cover-multi-bolso-iphone.png" alt="" />
            </div>
            <div class="home-beneficios__right">
              <div class="home-beneficios__title">
                Escolha qualquer produto de qualquer loja
              </div>
              <div class="home-beneficios__description">
                Você tem total liberdade para escolher exatamente o que quiser.
              </div>
              <ul class="home-beneficios__list">
                <li>Produtos exclusivos de pequenas marcas</li>
                <li>As melhores ofertas das grandes lojas</li>
              </ul>
            </div>
          </section>
          <section class="home-beneficios__item">
            <div class="home-beneficios__cover">
              <img
                src="../../assets//img/covers/cover-multi-recibiendo-dinero-002-br.webp"
                alt="Lista para recibir dinero en tu hucha."
              />
            </div>
            <div class="home-beneficios__right">
              <div class="home-beneficios__title">
                Receba também dinheiro para seus desejos
              </div>
              <div class="home-beneficios__description">
                Sua lista de desejos inclui um cofrinho digital onde você pode juntar dinheiro para compras específicas ou objetivos gerais.
              </div>
              <div class="home-beneficios__actions">
                <div
                  class="link link--bold link--underline"
                  @click="$router.push({ name: 'cofrinho-digital' })"
                >
                  Mais informações
                </div>
              </div>
            </div>
          </section>
          <section class="home-beneficios__item">
            <div class="home-beneficios__cover">
              <img
                src="../../assets//img/covers/monitorizacion-precios-wishlist-BR.webp"
                alt="Ofrece la posibilidad de compartir las compras más caras"
              />
            </div>
            <div class="home-beneficios__right">
              <div class="home-beneficios__title">
                Compre no momento certo
              </div>
              <div class="home-beneficios__description">
                Avisamos você quando o preço dos seus produtos favoritos mudar.
              </div>
              <div class="home-beneficios__footnote">
                *Acompanhamos apenas os preços de lojas parceiras.
              </div>
            </div>
          </section>
        </div>
      </div>
    </main>
    <div class="feedback-int">
      <div class="bb-container">
        <div class="feedback-int__title">O que nossos usuários dizem</div>
        <div class="feedback-int__items">
          <VueSlickCarousel v-bind="reviewsSlider">
            <div class="feedback-int__item">
              <div class="feedback-user">
                <div class="feedback-user__cover">
                  <img src="../../assets/img/covers/testimonial-marta.jpg" alt="" />
                </div>
                <div class="feedback-user__content">
                  <div class="feedback-user__string">
                    "Um app super útil para criar listas de presentes, seja para a chegada de um bebê, um batizado ou um aniversário."
                  </div>
                  <div class="feedback-user__name">Stefanie</div>
                </div>
              </div>
            </div>
            <div class="feedback-int__item">
              <div class="feedback-user">
                <div class="feedback-user__cover">
                  <img src="../../assets/img/covers/testimonial-estefania.jpg" alt="" />
                </div>
                <div class="feedback-user__content">
                  <div class="feedback-user__string">
                    "Exatamente o que eu estava procurando. Eu não queria ficar limitado a apenas uma loja ou site para minha wishlist.”
                  </div>
                  <div class="feedback-user__name">Sarah</div>
                </div>
              </div>
            </div>
            <div class="feedback-int__item">
              <div class="feedback-user">
                <div class="feedback-user__cover">
                  <img src="../../assets/img/covers/testimonial-ichamar.jpg" alt="" />
                </div>
                <div class="feedback-user__content">
                  <div class="feedback-user__string">
                    “Um aplicativo muito prático para acompanhar o que é necessário, compartilhar com contatos e planejar o orçamento.”
                  </div>
                  <div class="feedback-user__name">João Carlos</div>
                </div>
              </div>
            </div>
          </VueSlickCarousel>
        </div>
      </div>
    </div>

    <section class="multi-share">
      <div class="bb-container">
        <div class="multi-share__container">
          <article class="multi-share__article">
            <div class="multi-share__title">Compartilhe seus desejos com facilidade</div>
            <div class="multi-share__description">
              Compartilhar sua lista é tão simples quanto copiar e colar um link. Sua família e amigos não precisam se registrar nem baixar nada.
            </div>
          </article>
          <picture class="multi-share__cover">
            <img
              src="../../assets/img/covers/cover-multi-men-share.png"
              alt="Comparte tus deseos fácilmente"
            />
          </picture>
        </div>
      </div>
    </section>

    <section class="cta-yellow-deseos">
      <div class="bb-container">
        <div class="cta-yellow-deseos__cta">
          <div class="cta-yellow-deseos__left">
            <div class="cta-yellow-deseos__title">
              Crie sua lista de desejos com seus produtos favoritos de qualquer loja.
            </div>
            <div class="cta-yellow-deseos__actions">
              <bbButton
                label="Comece agora"
                class="button--accent button--lg"
                @click="$router.push({ name: 'signup-pt' })"
              />
              <!-- <div
                class="link link--bold link--underline"
                @click="$router.push({ name: 'guest', params: { id: exampleListId } })"
              >
                Ver una lista de ejemplo
              </div> -->
            </div>
          </div>
          <div class="cta-yellow-deseos__cover">
            <img src="../../assets/img/covers/cover-multi-ext-share.png" alt="" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

import bbButton from "../../components/buttons/bbButton.vue";

export default {
  name: "HomePageBR",
  metaInfo() {
    return {
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            name: "HelloBB",
            operatingSystem: [
              //no estic segur del format per posar més d’un valor
              "ANDROID",
              "IOS",
            ],
            applicationCategory: "LifestyleApplication",
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: "4.5", //no aconsegueixo veure ratings, tu pots?
              ratingCount: "20", //no aconsegueixo veure ratings, tu pots?
            },
            offers: {
              "@type": "Offer",
              price: "0",
            },
          },
        },
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "HelloBB",
            legalName: "HelloBB S.L.",
            url: "https://www.hellobb.net",
            logo: "https://www.hellobb.net/logo-hellobb-dark.svg", //posar URL on tenim el logo
            description:
              "Pon en tu lista de nacimiento cualquier cosa de cualquier tienda.",
            foundingDate: "2022",
            address: {
              "@type": "PostalAddress",
              streetAddress: "C/ Pompeu Fabra 36",
              addressLocality: "Tortosa",
              addressRegion: "Tarragona",
              postalCode: "43500",
              addressCountry: {
                "@type": "Country",
                name: "Spain", //en anglés millor?
              },
            },
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              email: "hola@hellobb.net",
            },
            sameAs: [
              "https://www.instagram.com/holahellobebe/",
              "https://www.facebook.com/holahelloBB",
              "https://www.pinterest.es/holahelloBB/",
              "https://www.crunchbase.com/organization/hellobb",
            ],
          },
        },
      ],
      title: "HelloBB Wishlist, sua lista de desejos universal",
      htmlAttrs: {
        lang: "pt",
      },
      meta: [
        {
          name: "description",
          content:
            "Salve produtos de qualquer loja, arrecade dinheiro, compartilhe com facilidade… Descubra por que o HelloBB é o app de wishlist nº 1",
        },
        {
          itemprop: "image",
          content: "https://www.hellobb.net/images/cover-portada.08a0882.png",
        },
        {
          property: "og:url",
          content: "https://www.hellobb.net",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:title",
          content: "HelloBB Wishlist, tu lista de deseos sin límites.",
        },
        {
          property: "og:description",
          content:
            "Guarda productos de cualquier tienda, reúne dinero, comparte fácilmente... Descubre por qué HelloBB es la lista de deseos #1 en España.",
        },
        {
          property: "og:image",
          content: "https://www.hellobb.net/images/cover-portada.08a0882.png",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
        {
          name: "twitter:title",
          content: "HelloBB Wishlist, tu lista de deseos sin límites.",
        },
        {
          name: "twitter:description",
          content:
            "Guarda productos de cualquier tienda, reúne dinero, comparte fácilmente... Descubre por qué HelloBB es la lista de deseos #1 en España.",
        },
        {
          name: "twitter:image",
          content: "https://www.hellobb.net/images/cover-portada.08a0882.png",
        },
      ],
      link: [
        { rel: "canonical", href: "https://www.hellobb.net/pt" },
        { rel: "alternate", href: "https://www.hellobb.net", hreflang: "es" },
        { rel: "alternate", href: "https://www.hellobb.net/en", hreflang: "en" },
        { rel: "alternate", href: "https://www.hellobb.net/fr", hreflang: "fr" },
        { rel: "alternate", href: "https://www.hellobb.net/it", hreflang: "it" },
        { rel: "alternate", href: "https://www.hellobb.net/nl", hreflang: "nl" },
        { rel: "alternate", href: "https://www.hellobb.net/de", hreflang: "de" },
        { rel: "alternate", href: "https://www.hellobb.net/pt", hreflang: "pt" },
        { rel: "alternate", href: "https://www.hellobb.net", hreflang: "x-default" }
      ]
    };
  },
  components: {
    bbButton,
    VueSlickCarousel,
  },
  data() {
    return {
      verticales: [
        { name: "Lista de enxoval", path: "/lista-de-nascimento", cover: "/cover-hbbm-mujer-cuna.jpg" },
        { name: "Lista de casamento", cover: "/cover-hbbm-wedding.jpg" },
        { name: "Lista de aniversário", cover: "/cover-hbbm-globos.jpg" },
        { name: "Lista de Natal", cover: "/cover-hbbm-navidad.jpg" },
        {
          name: "Lista de chá de bebê", path: "/lista-de-nascimento", cover: "/cover-hbbm-babby-shower.jpg",
        },
        { name: "Lista de presentes de inauguração de casa", cover: "/cover-hbbm-nueva-casa.jpg" },
      ],
      verticalesSlider: {
        slidesToShow: 4,
        arrows: false,
        autoplay: true,
        dots: false,
        slidesToScroll: 1,
        centerMode: true,
        speed: 900,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            variableWidth: true,
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              dots: true,
            },
          },
        ],
      },
      shopSlider: {
        slidesToShow: 8,
        arrows: false,
        autoplay: true,
        dots: false,

        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "20px",
        edgeFriction: 0.35,
        speed: 500,
        responsive: [
          {
            breakpoint: 1000000,
            settings: {
              slidesToShow: 8,
              // variableWidth: true,
            },
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            variableWidth: true,
            breakpoint: 767,
            settings: {
              // autoplay: false,
              slidesToShow: 2,
              variableWidth: true,
            },
          },
        ],
      },
      reviewsSlider: {
        slidesToShow: 3,
        arrows: false,
        autoplay: true,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 767,
            settings: {
              centerMode: true,
              slidesToShow: 1,
            },
          },
        ],
      },
    };
  },
  computed: {
    exampleListId() {
      return process.env.PREVIEW_LIST_ES_ID;
    },
  },
};
</script>

<style lang="scss" scoped></style>
